module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAgUlEQVQ4T7WTiwmAMAwFr5PoJrqJukmdRN1EN3EUiTQQFDWlWCi0kOt7+TRQsEIBi8ITsAG747EakB0VjnJxgBpyxv8Kiz1JaQRW4+xTWQIqYEmQC76qtTlwb+zNQBZsKypnteuybTsmql3KOxt+av1ntd9m5gbLaHrHswGGoo9xAORTJxCYpL9lAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play.png
// module id = VZWR
// module chunks = 2